/**
 * Autocomplete — select custom con ricerca testuale
 *
 * Uso:
 *   <div x-data="autocomplete({
 *       items: [{ id: 1, name: 'Fisioterapista' }, ...],
 *       selected: 0,
 *       name: 'occupation',
 *       placeholder: 'Seleziona professione'
 *   })">
 */
export function registerAutocomplete(Alpine) {
    Alpine.data('autocomplete', ({ items = [], selected = 0, name = '', placeholder = '' }) => ({
        items,
        name,
        placeholder,
        open: false,
        search: '',
        selectedId: selected,

        get selectedLabel() {
            if (!this.selectedId) return '';
            const item = this.items.find(i => i.id == this.selectedId);
            return item ? item.name : '';
        },

        get filtered() {
            if (!this.search) return this.items;
            const q = this.search.toLowerCase();
            return this.items.filter(i => i.name.toLowerCase().includes(q));
        },

        toggle() {
            this.open ? this.close() : this.openDropdown();
        },

        openDropdown() {
            this.open = true;
            this.search = '';
            this.$nextTick(() => this.$refs.searchInput?.focus());
        },

        close() {
            this.open = false;
            this.search = '';
        },

        select(item) {
            this.selectedId = item.id;
            this.close();
            this.$dispatch('autocomplete-select', { name: this.name, id: item.id, label: item.name });
        },

        clear() {
            this.selectedId = 0;
            this.close();
        },
    }));
}
